import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

// TODO: Nueva paleta de colores para el dashboard?
// TODO: Personalización de esta paleta desde configuración cliente?
function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.tax_category.borne'),
      color: '#FF7C75'
    },
    {
      id: 2,
      name: i18n.t('tipos.tax_category.charged'),
      color: '#8AC0FF'
    },
  ]
}

export function TIPOS_CATEGORIA_IMPUESTOS (state) {
  return configHelper.getConfig(state, 'TIPOS_CATEGORIA_IMPUESTOS', GenerateConfig)
}
